export default __webpack_public_path__ + "static/media/smiley3-open.b374d324.svg";